import http from '../../utils/httpClient';
import moment from 'moment';
import swal from 'sweetalert2';
import router from '../../router';
const state = {
  micpopup: [],
  selectMicPopUp: {},
  selectedCategoryId: '',
  updateActivityData: {},
  selectedActivityIndex: -1,
  isUpdating: false,
  addActivityData: {
    name: '',
    word: '',
    question: '',
  },
};
const getters = {};
const actions = {
  fetchMicPopUp({ commit, dispatch }, { page = 1, limit = 0 }) {
    commit('toggleStoreUpdate');
    http
      .GET(`/api/micpopup?page=${page}&limit=${limit}`, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        const formatData = data.map(micpopup => ({
          ...micpopup,
          created_at: moment(micpopup.created_at).format('MMMM D YYYY h:mm a'),
          updated_at: moment(micpopup.updated_at).format('MMMM D YYYY h:mm a'),
        }));
        commit('storeMicPopUp', formatData);
      })
      .catch(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Cannot fetch micpopup at this time. Please try again',
            type: 'error',
          },
          {
            root: true,
          },
        );
      })
      .finally(() => commit('toggleStoreUpdate'));
  },
  selectMicPopUp({ commit }, id) {
    commit('storeSelectMicPopUp', { id, sub_id: '' });
  },
  selectCategory({ commit }, id) {
    commit('storeSelectCategory', id);
  },
  fetchSingleMicPopUp({ commit, dispatch }, { id, sub_id }) {
    commit('toggleStoreUpdate');
    http
      .GET(`/api/micpopup?category_id=${id}`, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        const formatData = data.map(micpopup => ({
          ...micpopup,
          created_at: moment(micpopup.created_at).format('MMMM D YYYY h:mm a'),
          updated_at: moment(micpopup.updated_at).format('MMMM D YYYY h:mm a'),
        }));
        commit('storeMicPopUp', formatData);
        commit('storeSelectMicPopUp', { id, sub_id });
      })
      .catch(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Cannot fetch micpopup at this time. Please try again',
            type: 'error',
          },
          {
            root: true,
          },
        );
      })
      .finally(() => commit('toggleStoreUpdate'));
  },
  updateActivityData({ commit }, { key, value }) {
    commit('storeUpdateActivityData', {
      key,
      value,
    });
  },
  updateActivity({ dispatch }, updateData) {
    if (Object.keys(updateData).length > 1) {
      http
        .PUT(
          '/api/micpopup/activity',
          {
            ...updateData,
          },
          {
            isAuthorization: true,
          },
        )
        .then(({ data }) => {
          dispatch(
            'appConfig/toggleAlert',
            {
              message: 'Update Activity Success.',
              type: 'success',
            },
            {
              root: true,
            },
          );
          dispatch('fetchSingleMicPopUp', {
            id: state.selectMicPopUp.category_id,
          });
        })
        .catch(() => {
          dispatch(
            'appConfig/toggleAlert',
            {
              message: 'Failed to update set. Please try again',
              type: 'error',
            },
            {
              root: true,
            },
          );
        });
    }
  },
  clearUpdateData({ commit }) {
    commit('clearStoreUpdateActivityData');
  },
  deleteActivity({ dispatch, state }, id) {
    swal
      .fire({
        titleText: 'Confirm Delete Activity',
        showCancelButton: true,
        type: 'warning',
      })
      .then(result => {
        if (result.value) {
          http
            .DELETE(`/api/micpopup/activity?_id=${id}`, {
              isAuthorization: true,
            })
            .then(({ data }) => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  message: 'Delete Successfully',
                  type: 'success',
                },
                { root: true },
              );
              dispatch('fetchSingleMicPopUp', {
                id: state.selectMicPopUp.category_id,
              });
            })
            .catch(() => {
              dispatch(
                'appConfig/toggleAlert',
                {
                  message: 'Cannot delete please try again later !',
                  type: 'error',
                },
                { root: true },
              );
            });
        }
      });
  },
  updateCreateActivityData({ commit }, { key, value }) {
    commit('storeCreateActivityData', {
      key,
      value,
    });
  },
  addActivity({ dispatch }, { category_id, ...data }) {
    const createActivityData = {
      category_id,
      activity: {
        ...data.activity,
      },
    };
    http
      .POST('/api/micpopup', createActivityData, {
        isAuthorization: true,
      })
      .then(({ data }) => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Create Activity success',
            type: 'success',
          },
          {
            root: true,
          },
        );
        dispatch('fetchSingleMicPopUp', { id: category_id });
        router.go({
          path: '/micpopup/detail',
          query: {
            id: category_id,
          },
        });
      })
      .catch(() => {
        dispatch(
          'appConfig/toggleAlert',
          {
            message: 'Create Activity failed',
            type: 'errpr',
          },
          {
            root: true,
          },
        );
      });
  },
};
const mutations = {
  toggleStoreUpdate(state) {
    state.isUpdating = !state.isUpdating;
  },
  storeMicPopUp(state, micpopupList) {
    state.micpopup = micpopupList;
  },
  storeSelectMicPopUp(state, { id, sub_id }) {
    if (id) {
      const index = state.micpopup.findIndex(
        micpopup => micpopup.category_id === id,
      );
      state.selectMicPopUp = state.micpopup[index];
      if (sub_id) {
        const activityIndex = state.selectMicPopUp.activities.findIndex(
          activity => activity._id === sub_id,
        );
        state.selectedActivityIndex = activityIndex;
      }
    } else {
      delete state.selectMicPopUp;
    }
  },
  storeSelectCategory(state, value) {
    if (value) {
      state.selectedCategoryId = value;
    } else {
      delete state.selectedCategoryId;
    }
  },
  storeUpdateActivityData(state, { key, value }) {
    state.updateActivityData = {
      ...state.updateActivityData,
      [key]: value,
    };
  },
  storeCreateActivityData(state, { key, value }) {
    if (value || value == 0) {
      state.addActivityData = {
        ...state.addActivityData,
        [key]: value,
      };
    } else {
      delete state.addActivityData[key];
    }
  },
  clearStoreUpdateActivityData(state) {
    Object.keys(state.updateActivityData).forEach(key => {
      if (key != '_id') {
        delete state.updateActivityData[key];
      }
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
